import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useId } from 'react';
import { useCallback } from 'preact/compat';
import useTimeout from 'beautiful-react-hooks/useTimeout';
function FormNotices(props) {
    const { message, type, handleClose, closeTimer, closable, } = props;
    const id = useId();
    const close = useCallback(() => {
        if (handleClose) {
            handleClose();
        }
    }, [handleClose]);
    useTimeout(close, closeTimer ?? 999999);
    return (_jsxs("div", { id: id, className: `notice notice--${type}`, children: [_jsx("span", { className: "notice__message", children: message }), closable && (_jsx("div", { className: "notice__actions", children: _jsx("button", { type: "button", className: "icon-button", onClick: close, "aria-label": "Remove notice", children: _jsx("svg", { children: _jsx("use", { xlinkHref: "#icon--tooltip-close" }) }) }) }))] }));
}
FormNotices.defaultProps = {
    closeTimer: undefined,
    closable: true,
    handleClose: () => { },
};
export default FormNotices;
